import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const MantenimientoArchivo = () => {

    return (
        <div className="listado" id="menu">
            <h2 className='tituloAccion'>Mantenimiento de Archivos</h2>
            <TableContainer>
                <Table sx={{minWidth: 500}} size="small" >
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell><a href="./MantArchivo-Ingreso">Ficha de Datos Básicos</a></TableCell>
                            <TableCell><a href="./MantArchivo-DatosMovimiento">Movimientos</a></TableCell>
                        </TableRow>
                        <TableRow>
                            {/*<TableCell><a href="./MantArchivo/AntAdmPublica">Antigüedad en la Administración Pública</a></TableCell>*/}
                            <TableCell><a href="./MantArchivo-cambioFuncionario">Modificación de Cargo</a></TableCell>
                            <TableCell><a href="./MantArchivo-CambioHorario">Horario</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo-HorarioCP">Horario CP</a></TableCell>
                            <TableCell><a href="./MantArchivo-HorasDiasInhabiles">Horas y Días Generados</a></TableCell>
                        </TableRow>
                        <TableRow>
                            {/*<TableCell><a href="./MantArchivo-HorarioVariado">Horario Variado</a></TableCell>*/}
                            {/*<TableCell><a href="./MantArchivo-LicenciaEspecial">Licencia</a></TableCell>*/}
                            <TableCell><a href="./MantArchivo-Subrogacion">Subrogación</a></TableCell>
                            <TableCell><a href="./MantArchivo-cargaMarcasMensual">Cargar Marcas Mensual</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo-FichaCalificaciones">Ficha de Calificaciones</a></TableCell>
                            <TableCell><a href="./MantArchivo-planillaDescuento">Planilla Descuento Mensual</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo-Feriados">Agregar Fechas Especiales</a></TableCell>
                            <TableCell><a href="./MantArchivo-Resoluciones">Resoluciones</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo-AgregarLicenciaSuspendida">Agregar Licencia Suspendida</a></TableCell>
                        </TableRow>
                        {/*<TableRow>
                            <TableCell><a href="./MantArchivo/AgregaLicencia">Agrega Licencia Reglamentaria y Antigüedad próx. ej.</a></TableCell>
                            <TableCell><a href="./MantArchivo/AgregaAsueto">Agrega Asueto -4 días- próx. ejercicio</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo/AgregaLicenciaFamiliarInternado">Agrega Lic. Familiar Internado -15 días- próx. ej.</a></TableCell>
                            <TableCell><a href="./MantArchivo/AgregaLicenciaEnfermo">Agrega Lic. Familiar Enfermo -30 días- próx. ej.</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><a href="./MantArchivo/AgregaLicenciaLey">Agrega Lic. Ley 17.242 -1 día- próx. ej.</a></TableCell>
                            <TableCell><a href="./MantArchivo/AgregaLicenciaEstudio">Agrega Lic. Estudio -20 días- próx. ej.</a></TableCell>
                        </TableRow>*/}
                    </TableBody>
                </Table>
            </TableContainer>

            {/*<ul>
                <li><a href="../MantArchivo/Ingreso">Ficha de Datos Básicos</a></li>
                <li><a href="../MantArchivo/DatosMovimiento">Datos de Movimientos</a></li>
                <li><a href="../MantArchivo/AntAdmPublica">Antigüedad en la Administración Pública</a></li>
                <li><a href="../MantArchivo/FichaCalificaciones">Ficha de Calificaciones</a></li>
                <li><a href="../MantArchivo/HorasDiasInhabiles">Horas y Días inhábiles</a></li>
                <li><a href="../MantArchivo/CambioHorario">Cambio de Horario</a></li>
                <li><a href="../MantArchivo/HorarioVariado">Horario Variado</a></li>
                <li><a href="../MantArchivo/LicenciaEspecial">Licencia Especial 30 años</a></li>
                <li><a href="../MantArchivo/LicReglamentaria">Lic. regl. / Asueto / Ant. / Ext. COVID Pendientes</a></li>
                <li><a href="../MantArchivo/ActualizarAntiguedad">Actualizar Antigüedad próx. ej.(Personal.dbf)</a></li>
                <li><a href="../MantArchivo/AgregaLicencia">Agrega Licencia Reglamentaria y Antigüedad próx. ej.</a></li>
                <li><a href="../MantArchivo/AgregaAsueto">Agrega Asueto -4 días- próx. ejercicio</a></li>
                <li><a href="../MantArchivo/AgregaLicenciaFamiliarInternado">Agrega Lic. Familiar Internado -15 días- próx. ej.</a></li>
                <li><a href="../MantArchivo/AgregaLicenciaEnfermo">Agrega Lic. Familiar Enfermo -30 días- próx. ej.</a></li>
                <li><a href="../MantArchivo/AgregaLicenciaLey">Agrega Lic. Ley 17.242 -1 día- próx. ej.</a></li>
                <li><a href="../MantArchivo/AgregaLicenciaEstudio">Agrega Lic. Estudio -20 días- próx. ej.</a></li>
            </ul>*/}
        </div>
    )
}

export default MantenimientoArchivo